import { render, staticRenderFns } from "./GateExitStatus.vue?vue&type=template&id=3b621572&"
import script from "./GateExitStatus.vue?vue&type=script&lang=js&"
export * from "./GateExitStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports